import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";
import { useLocation } from "react-router-dom";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//TODO trae toda als actas segun su estado y los filtros
export const getActas = async (params, payload) => {
  const newParams = { page: params.page + 1, pageSize: params.pageSize };
  handlerLoading({ loading: true, loadName: "get_actas" });
  try {
    const response = await axios().post("/get_actas", payload, { params: newParams });
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } 
};

//TODO trae toda als actas segun su estado y los filtros
export const getActasCsv = async (payload) => {
  // const newParams = { page: params.page + 1, pageSize: params.pageSize };
  handlerLoading({ loading: true, loadName: "get_actas_csv" });
  try {
    const response = await axios().post(`/get_actas_csv`, payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "get_actas_csv" });
  }
};

//TODO trae toda als actas segun su estado y los filtros
export const getActasNotificadorCsv = async (payload) => {
  // const newParams = { page: params.page + 1, pageSize: params.pageSize };
  handlerLoading({ loading: true, loadName: "get_actas_csv" });
  try {
    const response = await axios().post(`/get_actas_notificador_pag_csv`, payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "get_actas_csv" });
  }
};
